module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_family-184ab3e6b627573b77ef123bde84999e.webp";